import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import QuoteFeatureService from '@/service/QuoteFeatureService';

export const useViewQuoteStore = defineStore('viewQuoteStore', {
  state: () => ({
    quote: {},
    pdf: '',
    urlQuote: '',
    isRequote: false,
    isWorksheetRequote: false
  }),
  getters: {
    selectQuote: (state) => state.quote,
    selectPdfQuote: (state) => state.pdf,
    selectUrlQuote: (state) => state.urlQuote,
    selectIsRequote: (state) => state.isRequote,
    selectWorksheetRequote: (state) => state.isWorksheetRequote
  },
  actions: {
    async handleViewQuote(id) {
      try {
        const quoteFeatureService = new QuoteFeatureService();
        const res = await quoteFeatureService.viewQuote(id);
        if (res) {
          this.getPdfQuote(res.data.pdf);
          this.updateViewQuote(res.data);
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async reQuote(id) {
      try {
        const quoteFeatureService = new QuoteFeatureService();
        const res = await quoteFeatureService.reQuote(id);
        if (res) {
          this.getPdfQuote(res.data.pdf);
          this.updateViewQuote(res.data);
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async handleReQuoteWorkSheet(id) {
      try {
        const quoteFeatureService = new QuoteFeatureService();
        const res = await quoteFeatureService.reQuoteWorkSheet(id);
        if (res) {
          this.updateViewQuote(res.data);
          this.getPdfQuote(res.data.pdf);
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async handleViewClientCopy(id) {
      try {
        const quoteFeatureService = new QuoteFeatureService();
        const res = await quoteFeatureService.viewClientCopy(id);
        if (res) {
          this.getPdfQuote(res.data.pdf);
          this.clearQuote();
          this.updateViewQuote(res.data);
        }
      } catch (e) {
        this.clearQuote();
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async handleSubmitClientCopy(payload) {
      try {
        const quoteFeatureService = new QuoteFeatureService();
        const res = await quoteFeatureService.submitClientCopy(payload);
        const link = document.createElement('a');
        link.href = res.data.trim();
        link.target = '_blank';
        link.download = 'Client_copy.pdf';
        link.click();
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async handleViewUrlQuote(payload) {
      try {
        const quoteFeatureService = new QuoteFeatureService();
        const res = await quoteFeatureService.viewUrlQuote(payload.id, payload.type);
        if (res) {
          if (payload.type == 'INVOICE') {
            this.getUrlQuote(res.data + '?bookingNo=' + payload.id);
          } else {
            this.getUrlQuote(res.data);
          }
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },

    async viewPDF(id) {
      const quoteFeatureService = new QuoteFeatureService();
      const res = await quoteFeatureService.viewPDF(id);
      this.getPdfQuote(res?.data);
      return res?.data;
    },

    updateViewQuote(payload) {
      this.quote = payload;
    },

    getPdfQuote(payload) {
      this.pdf = payload;
    },

    getUrlQuote(payload) {
      this.urlQuote = payload;
    },

    clearQuote() {
      this.quote = {};
    },

    getAction(type) {
      if (type === 'requote') {
        this.isRequote = true;
      } else {
        this.isRequote = false;
      }
    },

    getActionRequoteFromWorksheet(removeState) {
      if (removeState) {
        this.isWorksheetRequote = false;
      } else {
        this.isWorksheetRequote = true;
      }
    },

    async previewPDF(id) {
      const quoteFeatureService = new QuoteFeatureService();
      const res = await quoteFeatureService.previewPDF(id);
      this.getPdfQuote(res?.data);
    },

    async viewPriceSummary(quoteId: string) {
      const quoteFeatureService = new QuoteFeatureService();
      const res = await quoteFeatureService.viewPriceSummary(quoteId);
      return res.data;
    }
  }
});
